import { sortVariants, defaultMapper, variantFilter } from './sortVariants';

var getVariantTypes = function getVariantTypes(variants) {
  return variants && variants[0].attributes.map(function (attribute) {
    return attribute.type;
  });
};

var getCurrentVariant = function getCurrentVariant(variants, currentPartNumber) {
  return variants.find(function (variant) {
    return variant.partNumber === currentPartNumber;
  });
}; // Note: this assumes there are a max of 2 variant types


var formatVariants = function formatVariants(variants, currentPartNumber) {
  var variantTypes = getVariantTypes(variants);
  var current = getCurrentVariant(variants, currentPartNumber);
  var variantsArray = [];
  variantTypes.forEach(function (type) {
    var otherAttribute = type === current.attributes[0].type ? 1 : 0;
    var filteredProducts = variantTypes.length > 1 ? variants.filter(variantFilter(current.attributes[otherAttribute].type, current.attributes[otherAttribute].value)) : variants;
    var variantsThatMatchType = filteredProducts.sort(sortVariants(defaultMapper(type))).map(function (variant) {
      var variantAttributes = variant.attributes.filter(function (attr) {
        return attr.type === type;
      })[0];
      return {
        type: type,
        partNumber: variant.partNumber,
        value: variantAttributes.value,
        shortValue: variantAttributes.shortValue,
        isActive: variant.partNumber === currentPartNumber,
        title: variantAttributes.title
      };
    });
    variantsArray.push({
      type: type,
      products: variantsThatMatchType
    });
  });
  return variantsArray;
};

export default formatVariants;
export { getCurrentVariant, getVariantTypes };